export enum ContentServiceStoryType {
  article = "article",
  breaking_news = "breaking_news",
  data_article = "data_article",
  slideshow = "slideshow",
  impact_scorecard = "impact_scorecard",
  interactive = "interactive",
  feature = "feature",
  quicktake = "quicktake",
  video = "video",
  letter = "letter",
  newsletter_campaign = "newsletter_campaign",
  author_session = "author_session",
  liveblog = "liveblog",
}

export enum ContentServiceSite {
  Business = "BBIZ",
  Businessweek = "BUSINESSWEEK",
  Citylab = "CITYLAB",
  Cojp = "COJP",
  Crypto = "CRYPTO",
  Economics = "ECONOMICS",
  Equality = "EQUALITY",
  Gadfly = "GADFLY",
  Green = "GREEN",
  Industries = "INDUSTRIES",
  Markets = "MARKETS",
  MarketsMagazine = "MARKETS_MAGAZINE",
  Politics = "BPOL",
  Pursuits = "PURSUITS",
  Quicktake = "QUICKTAKE",
  Sponsored = "SPONSORED",
  Technology = "TECHNOLOGY",
  View = "VIEW",
  Wealth = "WEALTH",
  WorkShift = "WORK_SHIFT",
}
